<template>
  <div class="log-in">
    <h1 v-t="'views.logIn.title'" class="mt-0"></h1>

    <el-alert
      v-if="errors.unauthorized.visible"
      :title="t.errors.unauthorized"
      type="error"
      show-icon
      @close="resetUnauthorizedAlert"
    />

    <el-form :model="form" @submit.native.prevent="onSubmit">
      <el-form-item :label="t.username">
        <el-input v-model="form.username"/>
      </el-form-item>
      <el-form-item :label="t.password">
        <el-input v-model="form.password" show-password/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" native-type="submit" v-t="'views.logIn.submit'"/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getI18nPropertyKeys, translateProperty } from '@/lib/util';

export default {
  name: 'LogIn',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      errors: {
        unauthorized: {
          visible: false,
        },
      },
    };
  },
  computed: {
    t() {
      return {
        username: translateProperty('user', 'username'),
        password: translateProperty('user', 'password'),
        errors: {
          unauthorized: this.$t('views.logIn.errors.unauthorized'),
        },
      };
    },
  },
  methods: {
    ...mapActions(['logIn', 'loadResources']),
    getI18nPropertyKeys,
    showUnauthorizedAlert() {
      this.errors.unauthorized.visible = true;
    },
    resetUnauthorizedAlert() {
      this.errors.unauthorized.visible = false;
    },
    async onSubmit() {
      try {
        await this.logIn({ credentials: this.form });
        await this.loadResources();
        this.$router.push('/');
      } catch (err) {
        if (err.response && err.response.status === 401) {
          this.showUnauthorizedAlert();
        }
      }
    },
  },
};
</script>

<style scoped lang="sass">
  .log-in
    margin: auto
    width: 500px
</style>
